import { Action } from '@ngrx/store';
import { IHoliday } from '@signal/asp-data-commons';
export enum HolidayActionTypes {
  LOAD_HOLIDAYS_BY_YEAR = '[Holiday] Load Holidays By Year',
  LOAD_HOLIDAYS = '[Holiday] Load Holidays',
  LOAD_HOLIDAYS_SUCCESS = '[Holiday] Load Holidays success',
  LOAD_HOLIDAYS_FAILURE = '[Holiday] Load Holidays failure',
  CREATE_HOLIDAY = '[Holiday] Create Holiday',
  CREATE_HOLIDAY_SUCCESS = '[Holiday] Create Holiday Success',
  CREATE_HOLIDAY_FAIL = '[Holiday] Create Holiday Fail',
  UPDATE_HOLIDAY = '[Holiday] Update Holiday',
  UPDATE_HOLIDAY_SUCCESS = '[Holiday] Update Holiday Success',
  UPDATE_HOLIDAY_FAIL = '[Holiday] Update Holiday Fail',
  DELETE_HOLIDAY = '[Holiday] Delete Holiday',
  DELETE_HOLIDAY_SUCCESS = '[Holiday] Delete Holiday Success',
  DELETE_HOLIDAY_FAIL = '[Holiday] Delete Holiday Fail'
}

export class LoadHolidays implements Action {
  readonly type: string = HolidayActionTypes.LOAD_HOLIDAYS;

  constructor(public payload: { activeYear: string, department: string }) {
  }
}
export class LoadHolidaysByYear implements Action {
  readonly type: string = HolidayActionTypes.LOAD_HOLIDAYS_BY_YEAR;

  constructor(public payload: { activeYear: string, department: string }) {
  }
}

export class LoadHolidaysSuccess implements Action {
  readonly type = HolidayActionTypes.LOAD_HOLIDAYS_SUCCESS;
  constructor(public payload: { holidays: IHoliday[] }) {
  }
}

export class LoadHolidaysFail implements Action {
  readonly type = HolidayActionTypes.LOAD_HOLIDAYS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class CreateHoliday implements Action {
  readonly type = HolidayActionTypes.CREATE_HOLIDAY;

  constructor(public payload: {department:string, holiday: IHoliday}) {}
}

export class CreateHolidaySuccess implements Action {
  readonly type = HolidayActionTypes.CREATE_HOLIDAY_SUCCESS;

  constructor(public payload: IHoliday) {}
}

export class CreateHolidayFail implements Action {
  readonly type = HolidayActionTypes.CREATE_HOLIDAY_FAIL;

  constructor(public payload: { error: string }) {}
}

export class UpdateHoliday implements Action {
  readonly type = HolidayActionTypes.UPDATE_HOLIDAY;

  constructor(public payload: {department:string, holiday: IHoliday}) {}
}

export class UpdateHolidaySuccess implements Action {
  readonly type = HolidayActionTypes.UPDATE_HOLIDAY_SUCCESS;

  constructor(public payload: IHoliday) {}
}

export class UpdateHolidayFail implements Action {
  readonly type = HolidayActionTypes.UPDATE_HOLIDAY_FAIL;

  constructor(public payload: { error: string }) {}
}

export class DeleteHoliday implements Action {
  readonly type = HolidayActionTypes.DELETE_HOLIDAY;

  constructor(public payload: {department:string, holidayId: string}) {}
}

export class DeleteHolidaySuccess implements Action {
  readonly type = HolidayActionTypes.DELETE_HOLIDAY_SUCCESS;

  constructor(public payload: string) {}
}

export class DeleteHolidayFail implements Action {
  readonly type = HolidayActionTypes.DELETE_HOLIDAY_FAIL;

  constructor(public payload: { error: string }) {
  }
}


export type HolidayActions =
  | LoadHolidaysByYear
  | LoadHolidays
  | LoadHolidaysSuccess
  | LoadHolidaysFail
  | CreateHoliday
  | CreateHolidaySuccess
  | CreateHolidayFail
  | UpdateHoliday
  | UpdateHolidaySuccess
  | UpdateHolidayFail
  | DeleteHoliday
  | DeleteHolidaySuccess
  | DeleteHolidayFail;
